(()=>{
  const open=(id,trigger)=>{const d=document.getElementById(id);if(!d||d.open)return;d.showModal();trigger?.setAttribute('aria-expanded','true');d.addEventListener('close',()=>trigger?.setAttribute('aria-expanded','false'),{once:true});};
  document.addEventListener('click',e=>{
    const pause=e.target.closest('[data-mh-announcement-pause]');if(pause){const banner=pause.closest('[data-mh-announcement]');const paused=banner.classList.toggle('is-paused');pause.setAttribute('aria-pressed',String(paused));pause.setAttribute('aria-label',paused?'Duyuruyu oynat':'Duyuruyu duraklat');return;}
    const menu=e.target.closest('[data-mh-menu-open]');if(menu){open('mh-menu',menu);return;}
    if(e.target.closest('[data-mh-payment-open]')){e.preventDefault();open('mh-payment-info');return;}
    const close=e.target.closest('[data-mh-dialog-close]');if(close){close.closest('dialog')?.close();return;}
    if(e.target.matches('.mh-menu-dialog,.mh-info-dialog,.mh-image-dialog')){const b=e.target.getBoundingClientRect();if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)e.target.close();}
    const zoom=e.target.closest('[data-mh-zoom]');if(zoom){const src=zoom.parentElement.querySelector('img');if(!src)return;let d=document.getElementById('mh-image-zoom');if(!d){d=document.createElement('dialog');d.id='mh-image-zoom';d.className='mh-image-dialog';const img=document.createElement('img');const button=document.createElement('button');button.type='button';button.className='mh-icon-button';button.setAttribute('data-mh-dialog-close','');button.setAttribute('aria-label','Kapat');button.textContent='×';d.append(img,button);document.body.append(d);}const img=d.querySelector('img');img.src=src.dataset.zoomSrc||src.currentSrc||src.src;img.alt=src.alt;open(d.id);}
  });
  const cartCount=async()=>{try{const r=await fetch((window.Shopify?.routes?.root||'/')+'cart.js',{headers:{Accept:'application/json'}});if(!r.ok)return;const c=await r.json();document.querySelectorAll('[data-cart-count]').forEach(b=>{b.textContent=c.item_count;b.hidden=!c.item_count;});}catch{}};
  document.addEventListener('cart:update',cartCount);window.addEventListener('pageshow',e=>{if(e.persisted)cartCount();});
  document.addEventListener('variant:update',e=>{const data=e.detail?.data;if(!data?.html)return;const current=[...document.querySelectorAll('.mh-generated-gallery')].find(el=>el.dataset.productId===String(data.productId));const replacement=[...data.html.querySelectorAll('.mh-generated-gallery')].find(el=>el.dataset.productId===String(data.productId));if(current&&replacement)current.replaceWith(replacement.cloneNode(true));});
  let observer;
  const videos=()=>{
    const all=[...document.querySelectorAll('[data-mh-video]')];
    if(!all.length)return;
    if('IntersectionObserver' in window){
      observer?.disconnect();
      observer=new IntersectionObserver(entries=>{
        for(const entry of entries)if(!entry.isIntersecting)entry.target.pause();
      },{threshold:.2});
      all.forEach(video=>observer.observe(video));
    }
    all.forEach(video=>{
      if(video.dataset.bound)return;
      video.dataset.bound='true';
      video.autoplay=false;
      const frame=video.closest('.mh-video-frame');
      const cover=frame?.querySelector('[data-mh-video-play]');
      if(cover){
        video.controls=false;
        cover.hidden=false;
        cover.addEventListener('click',async()=>{
          cover.disabled=true;
          try{await video.play();}
          catch{video.controls=true;cover.hidden=true;}
          finally{cover.disabled=false;}
        });
      }
      video.addEventListener('play',()=>{
        video.controls=true;
        if(frame)frame.dataset.videoStarted='true';
        if(cover)cover.hidden=true;
        document.querySelectorAll('[data-mh-video]').forEach(other=>{if(other!==video)other.pause();});
      });
      video.addEventListener('pause',()=>{if(cover)cover.hidden=false;});
      video.addEventListener('ended',()=>{if(cover)cover.hidden=false;});
    });
  };
  videos();document.addEventListener('shopify:section:load',videos);document.addEventListener('visibilitychange',()=>{if(document.hidden)document.querySelectorAll('[data-mh-video]').forEach(v=>v.pause());});
})();
